<template>
  <v-dialog
    v-model="display"
    width="700"
  > 
  <v-card>
    <v-system-bar
      color="#0f74bb"
      height="40"
      class="advanced-search-header"
    >
      <v-spacer></v-spacer>
      <span>Advanced Search</span>
      <v-spacer></v-spacer>
      <v-icon color="white" @click="close">mdi-close</v-icon>
    </v-system-bar>
    <v-card-text>
      <br>
      <v-row>
        <v-col cols="4">
          <v-select 
            v-model="selectedCategory"
            label="Category"
            :items="FilteredSearchType"
            item-text="label"
            item-value="value"
          >
          </v-select>
        </v-col>
      </v-row>

      <div>
        <component 
          :is="selectedCategory"
          :reset="reset"
          @updatedSearchCriteria="updateSearchPayload"
          @updatedDateRange="updatedDateRange"
        />

        <br>
        <v-row>
          <v-spacer/>
          <v-btn 
            text
            @click="incrementReset"
          >
            Clear All
          </v-btn>
          <v-btn 
            v-if="!loading" 
            text
            @click="submit"
          >
            Search
          </v-btn>
          <v-progress-circular
            v-else
            indeterminate
          ></v-progress-circular>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
    

  </v-dialog>
</template>

<script>

import { search } from '@/mixins/quickSearch.js'

// import { Logger } from "aws-amplify"
// const logger = new Logger("Global Search / Advanced Search")

import Jobs from './types/Jobs.vue';
import Vehicles from './types/Vehicles.vue';
import Devices from './types/Devices.vue';

import { AmplifyEventBus } from "aws-amplify-vue"

export default {
  name: 'AdvancedSearch',
  components: {
    Jobs,
    Vehicles,
    Devices
  },
  mixins: [ search ],
  props: {
    display: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      categories: [
        {
          label: 'Jobs',
          value: 'jobs'
        },
        {
          label: 'Vehicles',
          value: 'vehicles'
        },
        {
          label: 'Devices',
          value: 'devices'
        }
      ],
      selectedCategory: '',
      reset: 0,
      searchPayload: {
        jobs: {
          category: '',
          sortBy: 'created_on',
          sortOrder: 'desc',
          pageSize: 100,
          pageNum: 1,
          criteria: [
            {
              attribute: 'start_timestamp',
              value: '',
              type: 'filter'
            },
            {
              attribute: 'end_timestamp',
              value: '',
              type: 'filter'
            },
            {
              attribute: '*',
              value: '',
              type: 'search'
            }
          ]
        },
        vehicles: {
          category: '',
          sortBy: 'created_on',
          sortOrder: 'desc',
          pageSize: 100,
          pageNum: 1,
          criteria: [ 
            {
              attribute: '*',
              value: '',
              type: 'search'
            }
          ]
        },
        devices: {
          category: '',
          sortBy: 'created_on',
          sortOrder: 'desc',
          pageSize: 100,
          pageNum: 1,
          criteria: [ 
            {
              attribute: '*',
              value: '',
              type: 'search'
            }
          ]
        }
      },
      typeMap: {
        jobs: {
          taskType: 'filter',
          jobTitle: 'search',
          jobCreatedBy: 'search',
          jobAssignee: 'search',
          taskTitle: 'search',
          taskAssignee: 'search',
          taskPerformedBy: 'search',
          installTag: 'search',
          vehicleName: 'search',
          organisation: 'search'
        },
        vehicles: {
          vehicle_name: 'search',
          organisation: 'search',
          group: 'search',
          vehicle_make: 'search',
          vehicle_year: 'filter',
          install_tag: 'search',
          vehicle_vin: 'search',
          vehicle_model: 'search'
        },
        devices: {
          device_status: 'filter',
          vehicle_name: 'search',
          organisation : 'search',
          install_tag: 'filter',
          imei: 'search',
          otc: 'filter',
          model: 'filter',
          firmware_version: 'filter',
          disabled: 'filter',
          is_default: 'filter'
        }
        
      },
      loading: false
    }
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    },
    FilteredSearchType () {
      const hidden = {
        'jobs': !this.$can('listJobs'),
        'vehicles': !this.$can('viewVehicle'),
      }
      return this.categories.filter(i => !hidden[i.value])
    }
  },
  watch: {
    selectedCategory: {
      handler(value) {
        this.searchPayload[this.selectedCategory].category = value;
      }
    }
  },
  mounted() {
    if(!this.selectedCategory.length > 0) {
      this.selectedCategory = this.categories[0].value;
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    returnSearchType(item) {
      if (!item || !this.typeMap[this.selectedCategory].hasOwnProperty(item)) return

      return this.typeMap[this.selectedCategory][item];
    },
    updateSearchPayload(terms) {
      const criteria = Object.keys(terms).map(item => {
        const obj = {
          attribute: '',
          value: '',
          type: ''
        };

        obj['attribute'] = item;
        obj['value'] = terms[item];
        obj['type'] = this.returnSearchType(item);

        return obj;
      });
      criteria.forEach(item => {
        let termExists = this.searchPayload[this.selectedCategory].criteria.find(term => term.attribute == item.attribute)
        // If the terms does not yet exist, add it to criteria
        if(!termExists && item.value != '') {
          this.searchPayload[this.selectedCategory].criteria.push(item)
        }
        // If it does exist, update the existsing with the latest values
        else {
          var foundIndex = this.searchPayload[this.selectedCategory].criteria.findIndex(index => index.attribute == item.attribute);

          this.searchPayload[this.selectedCategory].criteria[foundIndex] = item;
        }
      })
    },
    updatedDateRange(dates) {
      let start = this.searchPayload[this.selectedCategory].criteria.find(item => item.attribute == 'start_timestamp');
      let end = this.searchPayload[this.selectedCategory].criteria.find(item => item.attribute == 'end_timestamp');
      
      if(start && end) {
        start.value = dates[0];
        end.value = dates[1];
      }
    },
    incrementReset() {
      this.reset++;
    },
    async submit() {
      this.loading = true;

      try {
        const search = await this.quickSearch(this.searchPayload[this.selectedCategory], this.currentRoute);

        if (search.Result) {
          this.loading = false;
          this.close();
        }
        else {
          this.loading = false;
          this.close();
          AmplifyEventBus.$emit("snackEvent", {
            color: "error",
            text: 'An error occurred - please try again later'
          });
        }
      }
      catch {
        this.loading = false;
        this.close();
        AmplifyEventBus.$emit("snackEvent", {
          color: "error",
          text: 'An error occurred - please try again later'
        });
      }
    }
  }  
}
</script>

<style lang="scss" scoped>
  .advanced-search-header {
    color: white;
  }
</style>